import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FormService } from 'src/app/_services/submit-form.service'; // Adjust import path as necessary

const contactMethodValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const email = String(control.get('emailAddress')?.value || '').trim();
  const phone = String(control.get('phoneNumber')?.value || '').trim();

  return email || phone ? null : { contactMethodRequired: true };
};

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent {
  loading = false;
  successMessage = '';
  errorMessage = '';

  contactForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    emailAddress: new FormControl('', [Validators.email]),
    phoneNumber: new FormControl(''), // Add your own custom validator for phone numbers if needed
    message: new FormControl('', [Validators.required, Validators.maxLength(500)]),
  }, {
    validators: [contactMethodValidator]
  });

  constructor(private formService: FormService) {}

  get contactMethodErrorVisible(): boolean {
    return Boolean(
      this.contactForm.hasError('contactMethodRequired') &&
      (this.contactForm.controls.phoneNumber.touched || this.contactForm.controls.emailAddress.touched)
    );
  }

  submitForm() {
    this.loading = true;
    this.successMessage = '';
    this.errorMessage = '';

    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      this.loading = false;
      return;
    }

    if (this.contactForm.valid) {
      const formData = {
        ...this.contactForm.value,
        formType: "contact"
      }

      this.formService.submitFormData(formData).subscribe({
        next: (response) => {
          this.successMessage = 'Request submitted. GTX will follow up by phone, text, or email.';
          this.contactForm.reset();
          this.loading = false;
        },
        error: (error) => {
          this.errorMessage = `Error occurred when submitting form: ${error.status} ${error.message}`;
          this.loading = false;
        }
      });
    }
  }
}
